import React from 'react';
import {Table} from '@/web-components';
import {GLOBAL_FILTER_FIELD, GLOBAL_FILTER_OPERATOR} from '../../../../../constants';
import Util from '../../../../shared/util/util';
import {getCurrencyCell, getGroupedRowColumns} from '../TimeRegistrationReportTableUtil';
import {getQueryRenderer} from '../TimeRegistrationReportPageUtil';
import {DeprecatedProjectIndicatorNoFragment} from '../../../../shared/components/project-indicator/DeprecatedProjectIndicator';

export const getProjectRow = (
	data,
	intl,
	groupIndex,
	searchQuery,
	groupings,
	enabledColumns,
	hasNextPage,
	fetchMore,
	nextLevelProps,
	currency,
	reportId,
	sharedId,
	isSharedView,
	customFieldDefinitions,
	customFieldKeys
) => {
	const getColumns = project => {
		const hasAccessToProject = project.noProject ? true : project.fullAccessToProject;
		const projectName = project.noProject ? (
			intl.formatMessage({id: 'time_reg_report.no_project'})
		) : hasAccessToProject ? (
			<DeprecatedProjectIndicatorNoFragment
				project={project}
				disableLink={isSharedView || project.readOnlyAccess}
				clearSubPath
				showProjectName
			/>
		) : (
			intl.formatMessage({id: 'timesheets.no_access'})
		);
		return getGroupedRowColumns(
			{
				label: projectName,
				actualHours: Util.convertMinutesToFullHour(project.timeRegTotals?.totalTimeRegistered, intl, true),
				billableHours: Util.convertMinutesToFullHour(project.timeRegTotals?.totalBillableRegistered, intl, true),
				nonBillableHours: Util.convertMinutesToFullHour(project.timeRegTotals?.totalNonBillableRegistered, intl, true),
				actualBillableValueOfService: getCurrencyCell(
					project.timeRegTotals?.totalPrice,
					currency,
					intl,
					hasAccessToProject
				),
				actualCost: getCurrencyCell(project.timeRegTotals?.totalCost, currency, intl, hasAccessToProject),
			},
			customFieldDefinitions
		);
	};

	return (
		<Table.Rows
			data={data}
			canExpand={true}
			autoload={hasNextPage && groupIndex === 1}
			loadMore={hasNextPage ? fetchMore : false}
			{...nextLevelProps}
		>
			{({rowData, tableColumnsProps, nextLevelProps, expanded}) => {
				const filterField =
					rowData.noProject === true
						? GLOBAL_FILTER_FIELD.NON_PROJECT_TIME_REG
						: GLOBAL_FILTER_FIELD.PROJECT_TIME_REG;

				return (
					<>
						<Table.Row canExpandRow={rowData.canExpand} {...tableColumnsProps}>
							{getColumns(rowData)}
						</Table.Row>
						{expanded &&
							getQueryRenderer(
								null,
								groupings,
								searchQuery,
								groupIndex,
								enabledColumns,
								{field: filterField, operator: GLOBAL_FILTER_OPERATOR.IS, value: [rowData.projectId]},
								nextLevelProps,
								currency,
								reportId,
								sharedId,
								customFieldDefinitions,
								customFieldKeys
							)}
					</>
				);
			}}
		</Table.Rows>
	);
};
